// extracted by mini-css-extract-plugin
module.exports = {"icon-wrapper":"_99551c8aa8--icon-wrapper--JuVne"};